<body class="ltr main-body leftmenu">

    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="FeeReport">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-9">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                MIS report
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            MIS report </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Year</mat-label>
                                                            <mat-select #select55 class="colorblack"
                                                                formControlName="SessionId"
                                                                (selectionChange)="onSessionChange($event.value)">
                                                                <mat-select-filter *ngIf="select55.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CdCode'"
                                                                    [array]="codeTypeList"
                                                                    (filteredReturn)="filteredCodeType =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredCodeType"
                                                                    [id]="item.CdCode" [value]="item.CdCode">
                                                                    {{item.CdDesc}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="mt-1 mb-2">
                                        <div class="row mt-3">

                                            <!-- Total Collections -->
                                            <div class="col-sm-3">
                                                <div class="card dashboard-card bg-success">
                                                    <div class="card-body">
                                                        <h4>₹ {{TotalCollection}}</h4>
                                                        <p>{{totalCollectionLabel}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Total Registration -->
                                            <div class="col-sm-3">
                                                <div class="card dashboard-card bg-primary">
                                                    <div class="card-body">
                                                        <h4>{{TotalRegisteredStudents}}</h4>
                                                        <p>{{totalRegistrationLabel}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Today Collection -->
                                            <div class="col-sm-3">
                                                <div class="card dashboard-card bg-success">
                                                    <div class="card-body">
                                                        <h4>₹ {{TodayCollection}}</h4>
                                                        <p>{{todayCollectionLabel}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Today Registration -->
                                            <div class="col-sm-3">
                                                <div class="card dashboard-card bg-primary">
                                                    <div class="card-body">
                                                        <h4>{{TodayRegisteredStudents}}</h4>
                                                        <p>{{todayRegistrationLabel}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="row clearfix mt-3">
                                            <!-- <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Session</mat-label>
                                                            <mat-select  #select232 placeholder="Session"
                                                                class="colorblack" formControlName="SessionId" (selectionChange)="onSessionChange($event.value)">
                                                                <mat-select-filter *ngIf="select232.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                    [array]="sessionList"
                                                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of SessionFilterList"
                                                                    [value]="item.SnNo">
                                                                    {{item.SnName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>

                                                </div>
                                            </div> -->
                                            <!-- <div class="col-sm-3" >
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>Year</mat-label>
                        <mat-select #select55 class="colorblack" formControlName="SessionId" (selectionChange)="onSessionChange($event.value)">
                            <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                [displayMember]="'CdCode'" [array]="codeTypeList"
                                (filteredReturn)="filteredCodeType =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredCodeType" [id]="item.CdCode"
                            [value]="item.CdCode">
                                 {{item.CdDesc}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div> -->
                                            <!-- <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Fee Type</mat-label>
                                                        <mat-select placeholder="Fee Type" class="colorblack"
                                                            formControlName="FeeType"
                                                            (selectionChange)="onFeeTypeChange($event.value)">
                                                            <mat-option value="ALL">All Fee Types</mat-option>
                                                            <mat-option value="AF">Registration Fee</mat-option>
                                                            <mat-option value="EF">Exam Fee</mat-option>
                                                            <mat-option value="RC">Rank Certificate</mat-option>
                                                            <mat-option value="PC">Provisional Passing
                                                                Certificate</mat-option>
                                                            <mat-option value="OPC">Original Passing
                                                                Certificate</mat-option>
                                                            <mat-option value="MC">Migration Certificate</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div> -->
                                            <div class="col-sm-3" *ngIf="Table">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select22 placeholder="Course" class="colorblack"
                                                            formControlName="CoCode">
                                                            <mat-select-filter *ngIf="select22.focused"
                                                                [placeholder]="'Programme'" [displayMember]="'CoName'"
                                                                [array]="courseList"
                                                                (filteredReturn)="filteredCourseList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCourseList"
                                                                [value]="item.CoCode"
                                                                (click)="getCourseDataChange(item.CoCode)">
                                                                {{ item | displayValue:'CoCode':'CoName' }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-3" *ngIf="Table">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select #select225 placeholder="College" class="colorblack"
                                                            formControlName="CgCode">
                                                            <mat-select-filter *ngIf="select225.focused"
                                                                [placeholder]="'Study Center Name'"
                                                                [displayMember]="'CgName'" [array]="collegedataList"
                                                                (filteredReturn)="filteredListCollege =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCollege"
                                                                [value]="item.CgCode" (click)="clearData()">
                                                                {{ item | displayValue:'CgCode':'CgName' }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-3" *ngIf="Table">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline"
                                                        class="example-full-width date-field">
                                                        <mat-label>From Date</mat-label>
                                                        <input matInput [matDatepicker]="fromPicker"
                                                            formControlName="FromDate" maxlength="10" [max]="today"
                                                            (dateChange)="validateDates()" placeholder="DD/MM/YYYY">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="fromPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #fromPicker></mat-datepicker>
                                                        <mat-error *ngIf="FeeReport.controls.FromDate.errors?.maxDate">
                                                            From Date cannot be greater than today
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-3" *ngIf="Table">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline"
                                                        class="example-full-width date-field">
                                                        <mat-label>To Date</mat-label>
                                                        <input matInput [matDatepicker]="toPicker"
                                                            formControlName="ToDate" maxlength="10"
                                                            (dateChange)="validateDates()" placeholder="DD/MM/YYYY"
                                                            [max]="today" placeholder="To Date">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="toPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #toPicker></mat-datepicker>
                                                        <!-- From Date not selected -->
                                                        <mat-error
                                                            *ngIf="FeeReport.controls.ToDate.touched && FeeReport.controls.ToDate.errors?.fromRequired">
                                                            Please select From Date first
                                                        </mat-error>

                                                        <mat-error
                                                            *ngIf="FeeReport.controls.ToDate.touched && FeeReport.controls.ToDate.errors?.invalidDate">
                                                            To Date cannot be earlier than From Date
                                                        </mat-error>
                                                        <mat-error *ngIf="FeeReport.controls.ToDate.errors?.maxDate">
                                                            To Date cannot be greater than today
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12 prpl">
                                                    <button type="button" *ngIf="list"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                        (click)="back()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/refresh.gif">
                                                            Reset
                                                        </span>
                                                    </button>
                                                    <button *ngIf="list" type="button" (click)="fetchSummaryTable()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/list.gif"
                                                                style="margin-right: 7px;">
                                                            List
                                                        </span>
                                                    </button>
                                                    <button *ngIf="Table" type="button" (click)="goBackToSummary()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/refresh.gif"
                                                                style="margin-right: 7px;">
                                                            Back
                                                        </span>
                                                    </button>
                                                    <button *ngIf="downloadhide" type="button" (click)="download()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/images/arrow (1).png"
                                                                style="margin-right: 7px;">
                                                            Download
                                                        </span>
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                        <hr class="mt-3">
                                        <!-- <div class="col-md-3" [formGroup]="SearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search</mat-label> 
                                                <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div> -->
                                        <div class="col-sm-4" *ngIf="Table">
                                            <h6><b>Total Count : {{TotalCount}}</b></h6>
                                        </div>
                                        <div class="col-sm-12 pl-0" *ngIf="showSummaryTable">
                                            <div>
                                                <div class="table-responsive table-container" id="table">
                                                    <table class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th class="f600">Fee Type</th>
                                                                <th class="f600">Total Student</th>
                                                                <th class="f600">Total Amount</th>
                                                                <th class="f600">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="curs">
                                                            <tr *ngFor="let item of summaryData">
                                                                <td>{{ feeTypeMap[item.FeeType] }}</td>
                                                                <td>{{ item.TotalRegisteredStudents }}</td>
                                                                <td>₹ {{ item.TotalCollection }}</td>
                                                                <td class="text-center"
                                                                    (click)="viewDetails(item.FeeType)"> <a>
                                                                        <label class="blue_col">View</label></a>
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 pl-0" *ngIf="Table">
                                            <div>
                                                <div class="table-responsive table-container" id="table">
                                                    <table class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr class="text-left">
                                                                <th class="f600">
                                                                    Sr No
                                                                </th>
                                                                <th class="f600">
                                                                    Student Name
                                                                </th>
                                                                <th class="f600">
                                                                    Father Name
                                                                </th>
                                                                <th class="f600">
                                                                    Mother Name
                                                                </th>
                                                                <th class="f600" *ngIf="!hideStudentDetailsColumns">
                                                                    Course
                                                                </th>
                                                                <th class="f600" *ngIf="!hideStudentDetailsColumns">Whether Student Migrated From</th>
                                                                <!-- <th class="f600">
                                                                    Branch
                                                                </th> -->
                                                                <th class="f600" *ngIf="!hideStudentDetailsColumns">
                                                                    College
                                                                </th>
                                                                <th class="f600" *ngIf="!hideStudentDetailsColumns">
                                                                    Academic Session
                                                                </th>
                                                                <th class="f600">
                                                                    Mobile Number
                                                                </th>
                                                                <th class="f600" *ngIf="!hideStudentDetailsColumns">
                                                                    Gender
                                                                </th>
                                                                <th class="f600">
                                                                    Email Id
                                                                </th>
                                                                <th class="f600" *ngIf="!hideStudentDetailsColumns">
                                                                    Dob
                                                                </th>
                                                                <th class="f600">
                                                                    Fee Type
                                                                </th>
                                                                <th class="f600">
                                                                    Amount (₹)
                                                                </th>
                                                                <th class="f600">
                                                                    Payment Mode
                                                                </th>
                                                                <th class="f600">
                                                                    TXN ID
                                                                </th>
                                                                <!-- <th class="f600">
                                                                    TXN Date
                                                                </th> -->
                                                                <th class="f600">
                                                                    Receipt Number
                                                                </th>
                                                                <th class="f600">
                                                                    Payment Date
                                                                </th>
                                                                <th class="f600">
                                                                    Fee Receipt
                                                                </th>
                                                                <!-- <th class="f600">
                                                                    Medium
                                                                </th>
                                                                <th class="f600">
                                                                    Subjects
                                                                </th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody class="curs">
                                                            <tr *ngFor="let item of GridData;">
                                                                <td style="text-align: center;">{{item.SrNo}}</td>
                                                                <td>{{item.FullName}}</td>
                                                                <td>{{item.MiddleName}}</td>
                                                                <td>{{item.MotherName}}</td>
                                                                <td *ngIf="!hideStudentDetailsColumns">{{item.CoName}}
                                                                </td>
                                                                <td *ngIf="!hideStudentDetailsColumns">{{item.StudentType}}</td>
                                                                <!-- <td>{{item.StrName}}</td> -->
                                                                <td *ngIf="!hideStudentDetailsColumns">{{item.CgName}}
                                                                </td>
                                                                <td *ngIf="!hideStudentDetailsColumns">{{item.AcademicYear}}</td>
                                                                <td>{{item.StuMobNumber}}</td>
                                                                <td *ngIf="!hideStudentDetailsColumns">{{item.Gender}}
                                                                </td>
                                                                <td>{{item.StuEmailId}}</td>
                                                                <td *ngIf="!hideStudentDetailsColumns">
                                                                    {{item.StuBirthDate | date:'dd/MM/yyyy' }}</td>
                                                                <!-- <td>{{item.FeeType}}</td> -->
                                                                <td>{{ feeTypeMap[item.FeeType] || item.FeeType }}</td>
                                                                <td>{{item.AmountPaid}}</td>
                                                                <td>{{item.mode}}</td>
                                                                <td>{{item.TransactionNo}}</td>
                                                                <!-- <td>{{item.FullName}}</td> -->
                                                                <td>{{item.ReceiptNo}}</td>
                                                                <td>{{ item.FeePaymentDate | date:'dd/MM/yyyy' }}</td>
                                                                <td><a><label (click)="addnewrecord(item)"
                                                                            class="blue_col">View</label></a></td>
                                                                <!-- <td>{{item.StuMediumDescription}}</td>
                                                                <td>
                                                                    <ng-container *ngFor="let subject of formatSubjects(item.StuSubjectName)">
                                                                        {{ subject.SubCode }} - {{ subject.Sub }} <br>
                                                                    </ng-container>
                                                                </td> -->

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>